'use strict';

module.exports = {
    LANG: 'ko-kr',
    SIGN: '로그인',
    REGISTER: '등록',
    QUICK_ACCESS: '빠른 방문',
    SIGN_JOIN: '로그인 혹은 무료로 가입하기!',
    NOT_MEMBER: '회원이 아니십니까?',
    ALREADY_MEMBER: '이미 알리익스프레스/알리바바 회원이십니까?',
    SHOW_ALL: '쇼 all',
    HIDE: '숨기기'
};